import Breadcrumb from './Breadcrumb'
import { connect } from 'react-redux'

const mapStatetoProps = state => ({
  locale: state.router.locale,
})

export default connect(mapStatetoProps)(Breadcrumb)
